/** Hook for consuming the project-limit wall guard context. */
// @ts-check
import { useContext } from 'react';
import { ProjectLimitWallContext } from '@/features/wall/context/ProjectLimitWallContext.def';

/** @returns {import('@/features/wall/context/ProjectLimitWallContext.def').ProjectLimitWallContextValue} */
export const useProjectLimitGuard = () => {
  const context = useContext(ProjectLimitWallContext);
  if (!context) {
    throw new Error(
      'useProjectLimitGuard must be used within a ProjectLimitWallProvider',
    );
  }
  return context;
};
